const data = require("static/data/data.json");

export default {
  data,
};
